import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Image from '@/components/image/image'

import * as styles from './header-background.module.scss'

type Props = {
  image: Record<string, unknown> | null
  title: string
  headline: string
  excerpt: string
}

const HeaderBackground: React.FC<Props> = (props) => {
  const { image, excerpt, title, headline } = props
  return (
    <header className={styles.header}>
      <div className={styles.bgImage}>
        <Image image={image} />
      </div>
      <Container className={styles.containerHeader}>
        <Row className="justify-content-center">
          <Col lg="12" className="text-center">
            <div className={styles.topic}>
              <p>{headline}</p>
            </div>
            <h1>{title}</h1>
            <Row className="justify-content-center">
              <Col xg="9" className="text-center">
                <p className={styles.excerpt}>{excerpt}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </header>
  )
}

export default HeaderBackground
